import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.XeroContactRequestForm.SalesSettingsPart', {
    defaultAccount: 'Default account',
    defaultAccountPlaceholder: 'Select Default account',
    trackingCategoryPlaceholder: 'Select {name}',
});
